import React, { FC } from 'react';

import { Skeleton } from '@rbilabs/universal-components';
import { centsToDollarString } from 'utils';

import { Typography } from 'components/ui';
import type { TypographyProps } from 'components/ui';
import { useUIContext } from 'state/ui';

export interface ICurrencyProps {
  isLoading?: boolean;
  amount?: number;
  prefix?: string;
  suffix?: string;
  hideCurrencySymbol?: boolean;
  id?: string;
  testID?: string;
  textProps?: TypographyProps;
  isBold?: boolean;
  focusable?: boolean;
}

export const Currency: FC<React.PropsWithChildren<ICurrencyProps>> = ({
  amount = 0,
  prefix = '',
  suffix = '',
  hideCurrencySymbol = false,
  isLoading,
  testID,
  textProps,
  isBold = false,
  focusable,
}) => {
  const { formatCurrencyForLocale } = useUIContext();
  const formattedAmount = hideCurrencySymbol
    ? centsToDollarString(amount)
    : formatCurrencyForLocale(amount);

  if (isLoading) {
    return <Skeleton.Text w="10" />;
  }

  return (
    <Typography
      testID={testID}
      accessibilityLabel={`${prefix}${formattedAmount}${suffix}`}
      variant="copyOne"
      bold={isBold}
      {...textProps}
      focusable={focusable}
    >
      {prefix}
      {formattedAmount}
      {suffix}
    </Typography>
  );
};

export default Currency;
